import _ from 'lodash'
import { createSelector } from 'reselect'
import { getMultiStart } from './multiStart/selectors'
import { getPinned } from './pinned/selectors'
import { getProfiles } from './profiles/selectors'
import { getTokens } from './tokens/selectors'
import { getOrder } from './order/selectors'

// What I want in localforage is something like this:
// multiStart: { tq: ['testuser_1'] }
// order: { tq: ['testuser_1'] }
// profiles: { tq: { testuser_1: 'myAwesomeProfile' } }
// tokens: { tq: { testuser_1: { access: '', refresh: '' } } }

// Need a better name...
const filterByPinnedArr = (pinned, list) =>
    // pinned: { serverId: ['userId'] }
    // list: { serverId: ['userId'] }

    // We reduce pinned since we only care about pinned accounts
    _.reduce(
        pinned,
        (filtered, userIds, serverId) => {
            // We pick only users that are in both lists, ordered by list
            const temp = _.intersection(list[serverId], userIds)
            // We only want to store the serverId if it has any users
            if (temp.length > 0) filtered[serverId] = temp
            // Finally we return our filtered list
            return filtered
        },
        {},
    )

const filterByPinned = (pinned, list) =>
    // pinned: { serverId: ['userId'] }
    // list: { serverId: { userId: {} } }

    // We reduce pinned since we only care about pinned accounts
    _.reduce(
        pinned,
        (filtered, userIds, serverId) => {
            // We pick only users that are in both lists
            const temp = _.pick(list[serverId], pinned[serverId])
            // We only want to store the serverId if it has any users
            if (!_.isEmpty(temp)) filtered[serverId] = { ...temp }
            // Finally we return our filtered list
            return filtered
        },
        {},
    )

// Get multiStart for pinned accounts only
const getMultiStartForStorage = createSelector([getPinned, getMultiStart], (pinned, multiStart) =>
    filterByPinnedArr(pinned, multiStart),
)

// Get order for pinned accounts only
const getOrderForStorage = createSelector([getPinned, getOrder], (pinned, ordered) =>
    filterByPinnedArr(pinned, ordered),
)

// Get tokens for pinned accounts only
const getTokensForStorage = createSelector([getPinned, getTokens], (pinned, tokens) =>
    filterByPinned(pinned, tokens),
)

// eslint-disable-next-line
export const getUsersForStorage = createSelector(
    [getMultiStartForStorage, getOrderForStorage, getProfiles, getTokensForStorage],
    (multiStart, order, profiles, tokens) => ({ multiStart, order, profiles, tokens }),
)



// WEBPACK FOOTER //
// ./src/features/Users/data/selectors.js